export default __webpack_public_path__ + "static/media/eventicon.a3efc073.svg";